import { useSelector } from 'react-redux'

import { getWatchlistResults, getWatchlistHasMore, getWatchlistIsFetchMore, getWatchlistIsLoading, getLatestWatchlistResults, getLatestWatchlistHasMore, getLatestWatchlistIsFetchMore, getLatestWatchlistIsLoading, getLatestProductResults, getLatestProductHasMore, getLatestProductIsFetchMore, getLatestProductIsLoading, getLatestWatchlistArticleById, getLatestProductArticleById, getWatchlistArticleById, getLatestWatchlistSelectedArticles, getLatestProductSelectedArticles, getWatchlistSelectedArticles } from '../store/modules/newsSdk/selectors'

/**
 * @description returns news articles
 * @returns
 */
export const useWatchlistNews = () => {
  return useSelector(getWatchlistResults)
}

/**
 * @description returns if there are more news articles to fetch
 * @returns
 */
export const useWatchlistHasMore = () => {
  return useSelector(getWatchlistHasMore)
}

/**
 * @description returns if the store is currently loading more news
 * @returns
 */
 export const useWatchlistIsFetchMore = () => {
  return useSelector(getWatchlistIsFetchMore)
}

/**
 * @description returns news articles
 * @returns
 */
 export const useLatestWatchlistNews = () => {
  return useSelector(getLatestWatchlistResults)
}

/**
 * @description returns if there are more news articles to fetch
 * @returns
 */
export const useLatestWatchlistHasMore = () => {
  return useSelector(getLatestWatchlistHasMore)
}

/**
 * @description returns if the store is currently loading more news
 * @returns
 */
 export const useLatestWatchlistIsFetchMore = () => {
  return useSelector(getLatestWatchlistIsFetchMore)
}

/**
 * @description returns news articles
 * @returns
 */
 export const useLatestProducttNews = () => {
  return useSelector(getLatestProductResults)
}

/**
 * @description returns if there are more news articles to fetch
 * @returns
 */
export const useLatestProductHasMore = () => {
  return useSelector(getLatestProductHasMore)
}

/**
 * @description returns if the store is currently loading more news
 * @returns
 */
 export const useLatestProductIsFetchMore = () => {
  return useSelector(getLatestProductIsFetchMore)
}

/**
 * @description returns if the store is currently loading news
 * @returns
 */
export const useWatchlistIsLoading = () => {
  return useSelector(getWatchlistIsLoading)
}

/**
 * @description returns if the store is currently loading news
 * @returns
 */
 export const useLatestWatchlistIsLoading = () => {
  return useSelector(getLatestWatchlistIsLoading)
}

/**
 * @description returns if the store is currently loading news
 * @returns
 */
 export const useLatestProductIsLoading = () => {
  return useSelector(getLatestProductIsLoading)
}

/**
 * @description returns selected news article
 * @returns
 */
 export const useWatchlistNewsArticle = ({ id }) => {
  return useSelector(getWatchlistArticleById({ id }))
}

/**
 * @description returns selected news article
 * @returns
 */
export const useLatestWatchlistNewsArticle = ({ id }) => {
  return useSelector(getLatestWatchlistArticleById({ id }))
}

/**
 * @description returns selected news article
 * @returns
 */
 export const useLatestProductNewsArticle = ({ id }) => {
  return useSelector(getLatestProductArticleById({ id }))
}

/**
 * @description returns all selected news articles
 * @returns
 */
 export const useWatchlistNewsArticles = () => {
  return useSelector(getWatchlistSelectedArticles)
}

/**
 * @description returns all selected news articles
 * @returns
 */
export const useLatestWatchlistNewsArticles = () => {
  return useSelector(getLatestWatchlistSelectedArticles)
}

/**
 * @description returns all selected news articles
 * @returns
 */
 export const useLatestProductNewsArticles = () => {
  return useSelector(getLatestProductSelectedArticles)
}
